import { PackageStatus } from "@/services/bedrock/dtos/DesignPackage";

export type Stage = 1 | 2 | 3 | 4;

export const STAGES: { stage: Stage; label: string }[] = [
  { stage: 1, label: "Understanding your request" },
  { stage: 2, label: "Choosing backgrounds" },
  { stage: 3, label: "Designing layout" },
  { stage: 4, label: "Rendering previews" },
];

export const DONE_LABEL = "Your design is ready";

const STAGE_BY_STATUS: Record<PackageStatus, Stage | "done" | "failed"> = {
  queued: 1,
  generating_images: 2,
  generating_html: 3,
  rendering_previews: 4,
  completed: "done",
  failed: "failed",
};

const DEFAULT_PERCENT: Record<Stage, number> = { 1: 10, 2: 35, 3: 60, 4: 90 };

export function stageForStatus(status: PackageStatus): Stage | "done" | "failed" {
  return STAGE_BY_STATUS[status];
}

/** The stage's default percent, unless the reported percent is larger. */
export function percentFor(status: PackageStatus, percent: number | null): number {
  const stage = stageForStatus(status);
  if (stage === "done") return 100;
  if (stage === "failed") return percent ?? 0;
  const fallback = DEFAULT_PERCENT[stage];
  return percent != null && percent > fallback ? Math.min(percent, 100) : fallback;
}
